"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessDefinitionHttpClient = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class ProcessDefinitionHttpClient extends BaseClient_1.BaseClient {
    async getAll(identity, offset, limit) {
        const url = this.buildUrl(index_1.restSettings.paths.getProcessDefinitions, offset, limit);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const result = response.result;
        return {
            processDefinitions: result.processDefinitions.map(Mappers_1.mapProcessDefinition),
            totalCount: result.totalCount,
        };
    }
    async getById(processDefinitionId, identity) {
        const endpoint = index_1.restSettings.paths.getProcessDefinitionById
            .replace(index_1.restSettings.params.processDefinitionId, processDefinitionId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const processDefinition = (0, Mappers_1.mapProcessDefinition)(response.result);
        return processDefinition;
    }
    async getByProcessModelId(processModelId, identity) {
        const endpoint = index_1.restSettings.paths.getProcessDefinitionForProcessModel
            .replace(index_1.restSettings.params.processModelId, processModelId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const processDefinition = (0, Mappers_1.mapProcessDefinition)(response.result);
        return processDefinition;
    }
    async getProcessModelLog(processModelId, correlationid, identity, offset, limit) {
        let endpoint = index_1.restSettings.paths.getLogForProcessModel
            .replace(index_1.restSettings.params.processModelId, processModelId);
        if (correlationid) {
            endpoint = `${endpoint}?correlation_id=${correlationid}`;
        }
        const url = this.buildUrl(endpoint, offset, limit);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            logEntries: response.result.logEntries.map(Mappers_1.mapLogEntry),
        };
        return mappedResult;
    }
    async getProcessModelKPIs(processModelId, identity, offset, limit) {
        const endpoint = index_1.restSettings.paths.getRuntimeInformationForProcessModel
            .replace(index_1.restSettings.params.processModelId, processModelId);
        const url = this.buildUrl(endpoint, offset, limit);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        return response.result;
    }
    async persistProcessDefinitions(xml, overwriteExisting, identity) {
        const httpPayload = {
            xml: xml,
            overwriteExisting: overwriteExisting,
        };
        const url = this.buildUrl(index_1.restSettings.paths.persistProcessDefinitions);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this.httpClient.post(url, httpPayload, requestAuthHeaders);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async deployFiles(filePaths, overwriteExisting, identity) {
        throw new atlas_engine_sdk_1.NotImplementedError('deployFiles is only supported in NodeJS environment.');
    }
    async startProcessInstance(options, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.startProcessInstance)
            .replace(index_1.restSettings.params.processModelId, options.processModelId);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const processStartRequest = {
            ...options,
            returnOn: atlas_engine_sdk_1.DataModels.ProcessInstances.StartCallbackType.CallbackOnProcessInstanceCreated,
        };
        const response = await this.httpClient.post(url, processStartRequest, requestAuthHeaders);
        return response.result;
    }
    async startProcessInstanceAndAwaitEndEvent(options, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.startProcessInstance);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const processStartRequest = {
            ...options,
            returnOn: atlas_engine_sdk_1.DataModels.ProcessInstances.StartCallbackType.CallbackOnProcessInstanceFinished,
        };
        const response = await this.httpClient.post(url, processStartRequest, requestAuthHeaders);
        return response.result;
    }
    async startProcessInstanceAndAwaitSpecificEndEvent(options, endEventId, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.startProcessInstance);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const processStartRequest = {
            ...options,
            returnOn: atlas_engine_sdk_1.DataModels.ProcessInstances.StartCallbackType.CallbackOnEndEventReached,
            endEventId: endEventId,
        };
        const response = await this.httpClient.post(url, processStartRequest, requestAuthHeaders);
        return response.result;
    }
    /**
     * @param deleteAllRelatedData Optional: If set to true, the Process Definition, as well as all related data, will be completely deleted.
     *                             Otherwise, the Process Definition will only be flagged as deleted, but all data will be kept.
     *                             Note that this won't do anything on engines with a version below v13.0.7.
     */
    async deleteById(processDefinitionId, identity, deleteAllRelatedData = false) {
        const endpoint = index_1.restSettings.paths.deleteProcessDefinition
            .replace(index_1.restSettings.params.processDefinitionId, processDefinitionId);
        let url = this.buildUrl(endpoint);
        if (deleteAllRelatedData) {
            url = this.addParameterToUrl(url, 'delete_all_related_data', deleteAllRelatedData);
        }
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this.httpClient.delete(url, requestAuthHeaders);
    }
}
exports.ProcessDefinitionHttpClient = ProcessDefinitionHttpClient;
//# sourceMappingURL=ProcessDefinitionHttpClient.js.map